import React from "react";
import { Button } from "../ui/Button";

export const SampleButtons = ({ items, setActiveItem, activeItem }) => {
  return (
    <>
      <div class="styling-wrap__type-items poppins-18-500">
        {items &&
          items.map((item) => {
            return (
              <Button
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                item={item}
              />
            );
          })}
      </div>
    </>
  );
};
